var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "data-testid": "visit-medical-report-page"
    }
  }, [_c('medical-report')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1ed1d7c","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Visit/components/VisitMedicalReport.vue
// module id = 557
// module chunks = 0